import { render, staticRenderFns } from "./SetShensu.vue?vue&type=template&id=6d5675a7"
import script from "./SetShensu.vue?vue&type=script&lang=js"
export * from "./SetShensu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5675a7')) {
      api.createRecord('6d5675a7', component.options)
    } else {
      api.reload('6d5675a7', component.options)
    }
    module.hot.accept("./SetShensu.vue?vue&type=template&id=6d5675a7", function () {
      api.rerender('6d5675a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/SetShensu.vue"
export default component.exports